import { Heading, Stack } from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { Accordion } from 'src/components/oneCorp/features/MealCredit/common/Accordion/Accordion';

export function AccordionStencil(): JSX.Element {
  return (
    <>
      <Stack y="md" bg="globals.white">
        <Accordion
          disabled
          header={() => <Heading variant="h6">People (0)</Heading>}
          body={() => null}
        />
      </Stack>
      <Stack bg="globals.white">
        <Accordion
          disabled
          header={() => <Heading variant="h6">Groups (0)</Heading>}
          body={() => null}
        />
      </Stack>
    </>
  );
}
